module.exports = __webpack_public_path__ + "static/media/woman-yoga-pose-image.f5f71538.webp";